import soundfile from '../assets/sounds/hotel-bell.wav';

export default new Audio(soundfile);
